import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { COMMENT_PREBUILT_LIMITED_CART_POPUP } from 'swag-client-common/constants';
import { isPreBuiltLimitedCartOpenedByCustomerSelector } from 'swag-client-common/redux/cart/cart.selectors';
import { showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { LookingForSomethingDifferentComponent } from './looking-for-smth-different';
const mapStateToProps = createStructuredSelector({
  isVisible: isPreBuiltLimitedCartOpenedByCustomerSelector
});
const mapDispatchToProps = dispatch => ({
  onClick: () => {
    dispatch(showPopup({
      popup: COMMENT_PREBUILT_LIMITED_CART_POPUP
    }));
  }
});
export const LookingForSomethingDifferent = connect(mapStateToProps, mapDispatchToProps)(LookingForSomethingDifferentComponent);